import { jsx as _jsx } from "react/jsx-runtime";
import { createContext, useContext, useState, useEffect } from 'react';
import { useAuth } from '@features/auth/AuthProvider';
const GlobalScopeContext = createContext(undefined);
export function GlobalScopeProvider({ children }) {
    const { user } = useAuth();
    // Default to the logged-in user's ID
    const [scope, setScope] = useState('all');
    useEffect(() => {
        if (user?.id && scope === 'all') {
            // Inicially, set to logged-in user if available. But await, what about "default to logged in user"?
            // Yes, default to logged in user's ID.
            setScope(user.id);
        }
    }, [user?.id, scope]); // Only run when user id becomes available or scope is 'all'
    return (_jsx(GlobalScopeContext.Provider, { value: { scope, setScope }, children: children }));
}
export function useGlobalScope() {
    const context = useContext(GlobalScopeContext);
    if (!context) {
        throw new Error('useGlobalScope must be used within a GlobalScopeProvider');
    }
    return context;
}
